/**
 * Maps backend process/integration keys to Spanish labels for UI.
 */
const PROCESS_LABELS: Record<string, string> = {
  catalogue: "Catálogo",
  catalog: "Catálogo",
  catalogo: "Catálogo",
  inventory: "Inventario",
  inventario: "Inventario",
  price: "Precios",
  prices: "Precios",
  precio: "Precios",
  precios: "Precios",
  order: "Órdenes",
  orders: "Órdenes",
  orden: "Órdenes",
  ordenes: "Órdenes",
  órdenes: "Órdenes",
};

/** Same order as sidebar menu (excluding Logs). */
export const PROCESS_MENU_ORDER = [
  "Órdenes",
  "Catálogo",
  "Inventario",
  "Precios",
] as const;

/**
 * Returns a Spanish display name for a process key or name.
 */
export const getProcessDisplayName = (
  processKeyOrName?: string | null
): string => {
  const raw = (processKeyOrName ?? "").trim();
  if (!raw) return "";

  const normalized = raw.toLowerCase();
  return PROCESS_LABELS[normalized] ?? raw;
};

/**
 * Sort rank matching sidebar menu order. Unknown processes go last.
 */
export const getProcessMenuOrder = (
  processKeyOrName?: string | null
): number => {
  const label = getProcessDisplayName(processKeyOrName);
  const index = PROCESS_MENU_ORDER.indexOf(
    label as (typeof PROCESS_MENU_ORDER)[number]
  );
  return index === -1 ? PROCESS_MENU_ORDER.length : index;
};
